import { useMemo } from "react"
import { Column, Footer } from "../shared/types"
import { TableCell } from "@mui/material"

type FooterData<T> = Footer<T> & {
    _colSpan: number
}

export interface RenderFooterProps<T> {
    rows: T[],
    columns: Column[],
    footers: Footer[]
}

export default function RenderFooter<T>({
    rows,
    columns,
    footers
}: RenderFooterProps<T>) {
    return useMemo(() => {
        const footerDataList = new Array<FooterData<T>>(columns.length);

        const findNextFreeIndex = () => footerDataList.findIndex(cell => !cell);

        // Assign footer position sequentially or by column key
        for (const footer of footers) {
            const index = footer.from == null
                ? findNextFreeIndex()
                : columns.findIndex(c => c.key == footer.from);

            if (index >= 0 && index < footerDataList.length) {
                footerDataList[index] = { ...footer, _colSpan: 0 };
            }
        }

        // Fill FooterDataList
        for (let i = 0; i < footerDataList.length; i++) {
            const footerData = footerDataList[i];
            if (footerData) {
                if (footerData.span === "fill") {
                    let len = 1;
                    for (let j = i + 1; j < footerDataList.length; j++) {
                        if (footerDataList[j]) break;
                        len += 1;
                    }
                    footerData._colSpan = len;
                } else {
                    footerData._colSpan = footerData.span || 1;
                }
            }
        }

        // Parse to JSX element
        return footerDataList.filter(Boolean).map((f, i) => (
            <TableCell key={i} align={f.align} colSpan={f._colSpan}>
                {f.render(rows)}
            </TableCell>
        ))
    }, [rows, columns, footers])
}